import { normalizeAdminApiBaseUrl } from './api-base-url'

export type AppEnvironment = 'local' | 'hml' | 'prd'

export type AppConfig = {
  environment: AppEnvironment
  apiBaseUrl: string
  publicApiBaseUrl: string
  widgetBaseUrl: string
  telemetryEnabled: boolean
  defaultLanguage: string
  faceLandmarkerModelPath: string
  poseLandmarkerModelPath: string
  faceLandmarkerFallbackUrl: string
  mediaPipeWasmPath: string
  tryOnAssetOrigins: string[]
  universalPostTryOnEnabled: boolean
}

function normalizeHttpUrl(value: string, field: string, environment: AppEnvironment) {
  const url = new URL(value)
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || !url.hostname) {
    throw new Error(`${field} inválida para ${environment}`)
  }
  if (environment !== 'local' && url.protocol !== 'https:') {
    throw new Error(`HTTPS obrigatório em ${field} para ${environment}`)
  }
  url.search = ''
  url.hash = ''
  return url.toString().replace(/\/+$/, '')
}

function normalizeOrigin(value: string, field: string, environment: AppEnvironment) {
  const url = new URL(value)
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || !url.hostname) {
    throw new Error(`${field} inválida para ${environment}`)
  }
  if (environment !== 'local' && url.protocol !== 'https:') {
    throw new Error(`HTTPS obrigatório em ${field} para ${environment}`)
  }
  return url.origin
}

function normalizeOriginList(values: string[], field: string, environment: AppEnvironment) {
  if (!Array.isArray(values)) throw new Error(`${field} deve ser uma lista`)
  return Array.from(new Set(values.map((value) => normalizeOrigin(value, field, environment))))
}

function normalizeAssetPath(value: string, field: string) {
  if (!value.startsWith('/') || value.startsWith('//') || value.includes('..') || value.includes('\\')) {
    throw new Error(`${field} deve ser um caminho local absoluto`)
  }
  return value.replace(/\/+$/, '')
}

function validateConfig(config: AppConfig) {
  if (typeof config.universalPostTryOnEnabled !== 'boolean') {
    throw new Error('universalPostTryOnEnabled deve ser booleano')
  }
  if (!['local', 'hml', 'prd'].includes(config.environment)) {
    throw new Error(`Ambiente inválido: ${config.environment}`)
  }
  return {
    ...config,
    apiBaseUrl: normalizeAdminApiBaseUrl(config.apiBaseUrl),
    publicApiBaseUrl: normalizeHttpUrl(config.publicApiBaseUrl, 'publicApiBaseUrl', config.environment),
    widgetBaseUrl: normalizeHttpUrl(config.widgetBaseUrl, 'widgetBaseUrl', config.environment),
    faceLandmarkerModelPath: normalizeAssetPath(config.faceLandmarkerModelPath, 'faceLandmarkerModelPath'),
    poseLandmarkerModelPath: normalizeAssetPath(config.poseLandmarkerModelPath, 'poseLandmarkerModelPath'),
    faceLandmarkerFallbackUrl: normalizeHttpUrl(config.faceLandmarkerFallbackUrl, 'faceLandmarkerFallbackUrl', config.environment),
    mediaPipeWasmPath: normalizeAssetPath(config.mediaPipeWasmPath, 'mediaPipeWasmPath'),
    tryOnAssetOrigins: normalizeOriginList(config.tryOnAssetOrigins, 'tryOnAssetOrigins', config.environment),
  }
}

export const appConfig = Object.freeze(validateConfig(__APP_CONFIG__))
